import { DocumentSearchContextAPI } from "../context/DocSearchContext";
import { useContext } from "react";

const useDocSearchContext = () => {
  const context = useContext(DocumentSearchContextAPI);
  return context
};

export default useDocSearchContext;
